










































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import Headline from '@/fields/text/AmetrasHeadlineFieldTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';
import DraggableTreeView from '@/views/structure/DraggableTreeView.vue';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import AdvancedConfirmDialog, {
  ConfirmationDialogButton,
  ConfirmationDialogConfig
} from '@/views/AdvancedConfirmDialog.vue';
import AmetrasInfoTooltipTemplate from '@/views/AmetrasInfoTooltipTemplate.vue';
import {cloneDeep} from 'lodash';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';

@Component({
  components: {
    AmetrasInfoTooltipTemplate,
    AdvancedConfirmDialog,
    DraggableTreeView,
    AmetrasCheckBoxTemplate,
    AmetrasFormularWrapper,
    AmetrasSelectFieldTemplate,
    AmetrasTextFieldTemplate,
    Headline,
    draggable
  }
})
export default class DataTableCustomColumnConfig extends Vue implements DialogInstance {

  @Prop({
    type: Object as () => DisguiseDto.DTIconUrlTableDto,
    required: false,
    default: () => {
      return {};
    }
  }) iconConfiguration!: DisguiseDto.DTIconUrlTableDto;
  @Prop({
    type: Object as () => DisguiseDto.DTCustomColumnConfigurationSettingsDto,
    required: false,
    default: () => {
      return {};
    }
  }) customColumnConfigurationSettings!: DisguiseDto.DTCustomColumnConfigurationSettingsDto;
  @Prop() tableUrl!: string;
  @Prop( {
      type: Object as () => DisguiseDto.DTInputConfigurationDto,
      required: false,
      default: () => {
        return {};
      }
  }) inputConfiguration!: DisguiseDto.DTInputConfigurationDto;

  showCustomizationConfiguration: boolean = false;
  iconsService = ICONS_SERVICE_INSTANCE;
  possibleColumnConfigurations: DisguiseDto.SelectDto[] = [];
  currentColumnConfig: DisguiseDto.ColumnConfigurationSelectionDto = {};
  confirmationDialogConfig: ConfirmationDialogConfig | null = null;
  sortedColumns: DisguiseDto.DTColumnsDto[] = [];
  tableMetaLoading: boolean = true;
  columnConfigSaving: boolean = false;
  dirty: boolean = false;
  selectedColumnConfigLoading: boolean = false;
  configurationIsValid: boolean | null = null;
  hideOverlay: boolean = false;
  $refs!: {
    formWrapper: AmetrasFormularWrapper
  };

  private allColumns: DisguiseDto.DTColumnsDto[] = [];

  onUpdateColumnPosition(event: { newIndex: number, oldIndex: number }) {
    const allColumnCopy = [...this.sortedColumns];
    const newIndex = event.newIndex || 0;
    const oldIndex = event.oldIndex || 0;

    const rowAtNewIndex = this.sortedColumns[newIndex];
    const rowAtOldIndex = this.sortedColumns[oldIndex];
    allColumnCopy[newIndex] = rowAtOldIndex;
    allColumnCopy[oldIndex] = rowAtNewIndex;

    this.sortedColumns = allColumnCopy;
    this.dirty = true;
  }

  closeCustomizationConfiguration() {
    this.showCustomizationConfiguration = false;
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
  }

  loadAndShowCustomizationConfiguration() {
    this.showCustomizationConfiguration = true;
    DIALOG_STACK_INSTANCE.registerDialog(this);
    this.definePossibleSelectableColumnConfigurations(this.customColumnConfigurationSettings);
    this.loadTableConfiguration();
  }

  selectColumnConfigurationByValue(filterValueOfFilterToBeSelected: string, shouldPreselectNewConfigIfCurrentIsNotEditable: boolean = false) {
    let newFilter: DisguiseDto.FilterConfigurationSelectionDto | undefined;
    for (const currentFilterConfig of (this.customColumnConfigurationSettings || {}).possibleConfigurations || []) {
      if (currentFilterConfig.value === filterValueOfFilterToBeSelected) {
        newFilter = currentFilterConfig;
        break;
      }
    }

    if (newFilter !== undefined && (!shouldPreselectNewConfigIfCurrentIsNotEditable || newFilter.isEditable === true)) {
      this.currentColumnConfig = newFilter;

      if (this.currentColumnConfig.isEditable === true) {
        this.selectedColumnConfigLoading = true;
        const configurationEndpointUrl = this.customColumnConfigurationSettings.configurationEndpointUrl || '';
        HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DTColumnConfigurationDto>(
            `${configurationEndpointUrl}${configurationEndpointUrl.indexOf('?') > 0 ? '&' : '?'}${URL_SERVICE_INSTANCE.serialize({
              value: this.currentColumnConfig.value,
              text: this.currentColumnConfig.text
            } as DisguiseDto.ColumnConfigurationSelectionDto)}`
        ).then((response) => {
          const allColumnsClone = cloneDeep(this.allColumns);
          const newSortedColumns = [];

          for (const currentSortedColumnKey of response.data.sortedColumnKeys || []) {
            const lookedupColumnIdx = allColumnsClone.findIndex((value) => value.key === currentSortedColumnKey);
            if (lookedupColumnIdx >= 0) {
              newSortedColumns.push(allColumnsClone.splice(lookedupColumnIdx, 1)[0]);
            }
          }

          for (const currentUnsortedColumn of allColumnsClone || []) {
            newSortedColumns.push(currentUnsortedColumn);
          }

          for (const column of newSortedColumns) {
            column.hidden = (response.data.hiddenColumnKeys || []).indexOf((column || {}).key || '') >= 0;
          }

          this.sortedColumns = newSortedColumns;
          this.selectedColumnConfigLoading = false;
          this.dirty = false;
        }, (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: this.customColumnConfigurationSettings.columnConfigurationFetchMetaFailedErrorMessage || '',
              color: 'error'
            });
          }
          this.selectedColumnConfigLoading = false;
          this.dirty = false;
        });
      } else {
        this.sortedColumns = [...this.allColumns];
        this.dirty = false;
      }
    } else {
      this.currentColumnConfig = {
        text: '',
        isEditable: true
      };
      this.sortedColumns = [...this.allColumns];
      this.dirty = false;
    }
  }

  deleteColumnConfiguration() {
    this.confirmationDialogConfig = {
      title: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDialogTitle,
      headerColor: 'primary',
      message: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteConfirmationDialogMessage || '',
      buttons: [{
        text: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteConfirmationDialogConfirmButtonText || '',
        title: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteConfirmationDialogConfirmButtonTooltip || '',
        disabled: false,
        loading: false,
        autoFocus: true,
        onClick: (button: ConfirmationDialogButton) => {
          button.loading = true;
          button.disabled = true;
          const configurationEndpointUrl = this.customColumnConfigurationSettings?.configurationEndpointUrl || '';
          const configurationEndpointUrlWithParams = configurationEndpointUrl + (configurationEndpointUrl.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize({
            value: this.currentColumnConfig.value,
            text: this.currentColumnConfig.text
          } as DisguiseDto.ColumnConfigurationSelectionDto);
          HTTP_SERVICE_INSTANCE.getAxios().delete(configurationEndpointUrlWithParams).then(() => {
            this.$store.commit('showSnack', {
              message: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteSuccessMessage || '',
              color: 'success'
            });
            this.closeCustomizationConfiguration();
            this.$emit('change', undefined);
            this.confirmationDialogConfig = null;
          }, (error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              this.$store.commit('showSnack', {
                message: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteFailMessage || '',
                color: 'error'
              });
            }
            button.loading = false;
            button.disabled = false;
          });
        }
      }, {
        text: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteConfirmationDialogAbortButtonText || '',
        title: (this.customColumnConfigurationSettings || {}).customizeColumnConfigurationDeleteConfirmationDialogAbortButtonTooltip || '',
        disabled: false,
        loading: false,
        onClick: () => {
          this.confirmationDialogConfig = null;
        }
      }],
      onEsc: () => {
        this.confirmationDialogConfig = null;
      }
    };
  }

  loadTableConfiguration() {
    this.tableMetaLoading = true;
    const serializedFilter = URL_SERVICE_INSTANCE.serialize((this.inputConfiguration || {}));
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DTTemplateDto>(
        `${this.tableUrl}${this.tableUrl.indexOf('?') > 0 ? '&' : '?'}metaData=true` + (serializedFilter ? '&' + serializedFilter : '')
    ).then((response) => {
      this.allColumns = response.data.columns || [];

      if (this.customColumnConfigurationSettings && this.customColumnConfigurationSettings.activeConfig && this.customColumnConfigurationSettings.activeConfig.value) {
        this.selectColumnConfigurationByValue(this.customColumnConfigurationSettings.activeConfig.value, true);
      }

      this.tableMetaLoading = false;
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: this.customColumnConfigurationSettings.columnConfigurationFetchMetaFailedErrorMessage || '',
          color: 'error'
        });
      }
      this.tableMetaLoading = false;
    });
  }

  onSubmitConfiguration() {
    if (this.$refs.formWrapper.validate()) {
      if (this.dirty) {
        this.columnConfigSaving = true;
        HTTP_SERVICE_INSTANCE.getAxios().post<DisguiseDto.DTColumnConfigurationDto>(
            `${this.customColumnConfigurationSettings.configurationEndpointUrl}`,
            {
              sortedColumnKeys: ((sortedColumns) => {
                const result: string[] = [];

                for (const currentColumn of sortedColumns || []) {
                  if (currentColumn.key) {
                    result.push(currentColumn.key);
                  }
                }

                return result;
              })(this.sortedColumns),
              hiddenColumnKeys: ((allColumns) => {
                const result: string[] = [];

                for (const currentColumn of allColumns || []) {
                  if (currentColumn.hidden === true && currentColumn.key) {
                    result.push(currentColumn.key);
                  }
                }

                return result;
              })(this.sortedColumns),
              text: this.currentColumnConfig.text,
              value: this.currentColumnConfig.value,
              isDefault: this.currentColumnConfig.isDefault
            } as DisguiseDto.DTColumnConfigurationDto
        ).then((response) => {
          this.$store.commit('showSnack', {
            message: this.customColumnConfigurationSettings.customizeColumnConfigurationSaveSuccessMessage || '',
            color: 'success'
          });
          this.columnConfigSaving = false;
          this.closeCustomizationConfiguration();
          this.$emit('change', {
            value: response.data.value,
            text: response.data.text
          } as DisguiseDto.ColumnConfigurationSelectionDto);
          this.confirmationDialogConfig = null;
        }, (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: this.customColumnConfigurationSettings.customizeColumnConfigurationSaveFailMessage || '',
              color: 'error'
            });
          }
          this.columnConfigSaving = false;
        });
      } else {
        this.closeCustomizationConfiguration();
        this.$emit('change', {
          text: this.currentColumnConfig.text,
          value: this.currentColumnConfig.value,
        } as DisguiseDto.ColumnConfigurationSelectionDto);
        this.confirmationDialogConfig = null;
      }
    }
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

  private definePossibleSelectableColumnConfigurations(columnConfig: DisguiseDto.DTCustomColumnConfigurationSettingsDto) {
    const newPossibleEditableColumnConfigurations: DisguiseDto.SelectDto[] = [];
    for (const currentConfiguration of (columnConfig || {}).possibleConfigurations || []) {
      const newColumnConfig = {
        text: `${currentConfiguration.text}${currentConfiguration.isDefault && currentConfiguration.isEditable ? columnConfig.defaultAppendix || '' : ''}`,
        value: currentConfiguration.value
      };
      newPossibleEditableColumnConfigurations.push(newColumnConfig);
    }
    this.possibleColumnConfigurations = newPossibleEditableColumnConfigurations;
  }


}
